export const ALEXA_LINKING_ENABLED = 'alexaSkill.accountLinking.enabled';
